"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CONTACT_POINT_ADDRESS = void 0;
exports.GET_CONTACT_POINT_ADDRESS = `
	query getContactPointAddress {
		getContactPointAddress {
			Id,
			Street,
			City,
			State,
			PostalCode,
			Country,
			AddressType,
			IsPrimary
		}  
	}
`;
//# sourceMappingURL=contact-point-queries.js.map